<script>
	import { onMount } from 'svelte';

	export var panels = [];
	export var visible = 1;
	export var navArrows = true;
	export var navDots = true;
	export var loop = true;
	export var delay = 2;

	var carousel;
	var timer;
	var active = 0;

	function setActive(i){
		if(loop){
			// Loop back to the beginning
			if(i + visible > panels.length){
				active = 0;
			// Loop to the end
			}else if(i < 0){
				active = panels.length - visible;
			// Somewhere in between
			}else{
				active = (i + panels.length) % panels.length;
			}
		}else{
			active = Math.min(Math.max(i, 0), panels.length - 1);
		}
		if (carousel){
			var newPos = (carousel.offsetWidth / visible) * active;
			carousel.querySelector('.panels').scrollLeft = newPos;
			startTimer();
		}	
	}
	
	function prev(){
		setActive(active - 1);
	}

	function next(){
		setActive(active + 1);
	}

	function startTimer(){
		clearTimeout(timer);

		if(delay){
			timer = setTimeout(next, delay * 1000);
		}
	}

	onMount(() => {
		// Stop browsers from "remembering" scroll position
		setActive(0);
		startTimer();
	});
</script>

<div class="carousel" bind:this={carousel}>
	<div class="panels">
		{#each panels as panel}
		<div class="panel" style={"flex: 0 0 " + (100 * (1 / visible)) + "%"}>
			<slot name="panel" {panel}></slot>
		</div>
		{/each}
	</div>

	{#if navArrows && panels.length > 1}
	<div class="nav-arrows">
		<button class="nav-arrow-prev" aria-label="Previous Image" disabled={!loop && active === 0} on:click={prev}>
			<svg class="icon"><use xlink:href="/icons.svg#keyboard_arrow_left"></use></svg>
		</button>
		<button class="nav-arrow-next" aria-label="Next Image" disabled={!loop && ((active + visible) >= panels.length)} on:click={next}>
			<svg class="icon"><use xlink:href="/icons.svg#keyboard_arrow_right"></use></svg>
		</button>
	</div>
	{/if}

	{#if navDots && panels.length > 1}
	<div class="nav-dots">
		{#each panels as p, i}
		<button class="nav-dot" class:active={active === i} on:click={() => setActive(i) }></button>
		{/each}
	</div>
	{/if}
</div>

<style type="text/less">
	.carousel{
		position: relative;
		overflow: hidden;

		&:hover{
			.nav-arrows{
				display: flex;
			}
		}
	}

	.panels{
		display: flex;
		align-items: stretch;
		z-index: 1;
		overflow: hidden;
		scroll-behavior: smooth;
		scroll-snap-type: mandatory;
	}
	.panel{
		flex: 0 0;
		box-sizing: border-box;
	}

	.nav-arrows{
		display: none;
		justify-content: space-between;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 3;
		pointer-events: none;
	}
	.nav-arrow-prev, .nav-arrow-next{
		flex: 0 0 auto;
		background: none;
		border: none;
		color: var(--col-gray-100);
		font-size: 5rem;
		cursor: pointer;
		pointer-events: all;
		padding: 0;
		line-height: 0;
	}
	.nav-arrow-prev .icon, .nav-arrow-next .icon{
		stroke: var(--col-gray-0);
		filter: drop-shadow(0 0 var(--shadow-size) rgba(0,0,0,0.5));
		stroke-width: .25px;
	}
	.nav-arrow-next{
		text-align: right;
	}
	.nav-arrow-prev[disabled], .nav-arrow-next[disabled]{
		opacity: 0;
		pointer-events: none;
	}

	.nav-dots{
		display: flex;
		justify-content: center;
		padding: var(--spacing-sm);
	}
	.nav-dot{
		background: var(--col-gray-60);
		width: 1.1rem;
		height: 1.1rem;
		margin: 0 var(--spacing-xs);
		padding: 0;
		cursor: pointer;
		border-radius: 50%;
		border: none;
	}

	.nav-arrow-prev:hover, .nav-arrow-next:hover,
	.nav-arrow-prev:active, .nav-arrow-next:active{
		background: none;
		color: var(--col-accent-1);
	}

	.nav-dot:hover, .nav-dot:active, .nav-dot.active{
		background: var(--col-accent-1);
	}
</style>